import React, { useRef, useState } from 'react';
import { uploadService } from '../services/api';

// Botão de upload de imagem com prévia. value = URL atual; onChange(url) após enviar.
// maxMB: limite (deve bater com o backend). Avisa o limite e valida ANTES de enviar.
export default function ImageUpload({ value, onChange, label = 'Imagem', height = 120, maxMB = 8 }) {
  const inputRef = useRef();
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  const pick = () => { setErr(''); inputRef.current?.click(); };

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    e.target.value = '';
    setErr('');
    // validação de tamanho antes de subir
    if (file.size > maxMB * 1024 * 1024) {
      const mb = (file.size / 1024 / 1024).toFixed(1);
      setErr(`Imagem muito grande (${mb} MB). O máximo é ${maxMB} MB — reduza o arquivo e tente de novo.`);
      return;
    }
    setLoading(true);
    try {
      const res = await uploadService.upload(file);
      onChange(res.data.url);
    } catch (e2) {
      const msg = e2.response?.data?.error || e2.message || 'Falha ao enviar';
      setErr(/large|grande/i.test(msg) ? `Imagem muito grande. O máximo é ${maxMB} MB.` : msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {label && <label style={styles.label}>{label}</label>}
      <div style={styles.row}>
        <div style={{ ...styles.preview, height }}>
          {value
            ? <img src={value} alt="" style={styles.img} />
            : <span style={styles.empty}>sem imagem</span>}
        </div>
        <div style={styles.actions}>
          <button type="button" style={styles.btn} onClick={pick} disabled={loading}>
            {loading ? 'Enviando…' : (value ? 'Trocar imagem' : 'Enviar imagem')}
          </button>
          {value && <button type="button" style={styles.btnRemove} onClick={() => onChange('')}>Remover</button>}
          <span style={styles.hint}>PNG, JPG, WEBP ou SVG · até {maxMB} MB</span>
        </div>
      </div>
      {err && <div style={styles.err}>{err}</div>}
      <input ref={inputRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleFile} />
    </div>
  );
}

const styles = {
  label: { display: 'block', color: '#9ca3af', fontSize: 13, fontWeight: 500, marginBottom: 6 },
  row: { display: 'flex', gap: 12, alignItems: 'flex-start' },
  preview: { width: 120, minWidth: 120, background: '#0a0a0f', border: '1px solid #374151', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' },
  img: { width: '100%', height: '100%', objectFit: 'cover' },
  empty: { color: '#6b7280', fontSize: 12 },
  actions: { display: 'flex', flexDirection: 'column', gap: 8, paddingTop: 4 },
  btn: { padding: '9px 14px', background: 'var(--accent)', color: '#0a0a0f', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600 },
  btnRemove: { padding: '7px 14px', background: 'transparent', color: '#f87171', border: '1px solid #7f1d1d', borderRadius: 8, cursor: 'pointer', fontSize: 13 },
  hint: { color: '#6b7280', fontSize: 12, marginTop: 2 },
  err: { color: '#f87171', fontSize: 13, marginTop: 8, background: 'rgba(248,113,113,0.08)', border: '1px solid #7f1d1d', borderRadius: 8, padding: '8px 12px' },
};
